export const STORAGE_KEYS = {
  CALIBRATION_STATUS: 'calibrationStatus',
  BRAND: 'brand',
  JingTaiMer68Traveler: 'JingTaiMer68Traveler',
  MER68SE_FIRST_USE: 'mer68seFirstUse',
  SOFTWARE_THEME: 'softwareTheme',
  VIRTUAL_KEYBOARD_APPEARANCE: 'virtualKeyboardAppearance',
  CUSTOM_BACKGROUND: 'customBackground',
}
